import * as yup from 'yup'
import * as Types from 'apps/fleet-planner/types'

export interface INewContact
  extends Pick<Types.ICustomerContact, 'name' | 'email' | 'phone' | 'phoneExt'> {}

export interface IExistingContact
  extends Pick<Types.ICustomerContact, 'id' | 'name' | 'email' | 'phone' | 'phoneExt'> {}

/**
 * Creates new contact
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Contacts/post_customers__id__contacts
 */
export const ContactSchema = yup
  .object<INewContact>({
    name: yup.string(),
    email: yup.string().email('Please enter a valid email.'),
    phone: yup.string().notRequired(),
    phoneExt: yup.string().notRequired(),
  })
  .test('form-invalid', 'Please enter either a phone, email, or name.', function testContact(
    value
  ) {
    const isContactInfoRequired = (this.options?.context as any)?.isContactInfoRequired || false
    if (!isContactInfoRequired) return true

    const { email, name, phone } = value || {}
    return !!(name || email || phone)
  })

export type ContactSchemaType = yup.InferType<typeof ContactSchema>
